"use client";

import {
  AutumnError,
  toContainerResult
} from "./chunk-JNJ53ZW6.mjs";
import {
  logFetchError
} from "./chunk-CIBQ4BJU.mjs";
import {
  attachMethod,
  cancelMethod,
  checkMethod,
  openBillingPortalMethod,
  trackMethod
} from "./chunk-LS3NB4DU.mjs";
import {
  createCode,
  redeemCode
} from "./chunk-TBCLSIC2.mjs";
import {
  getPricingTableMethod
} from "./chunk-NZ5PEXT2.mjs";
import {
  createCustomerMethod
} from "./chunk-TGX6UKKS.mjs";
import {
  createEntityMethod,
  deleteEntityMethod,
  getEntityMethod
} from "./chunk-4KKWHG2V.mjs";

// src/libraries/react/client/ReactAutumnClient.tsx
var AutumnClient = class {
  backendUrl;
  getBearerToken;
  customerData;
  includeCredentials;
  constructor({
    backendUrl,
    getBearerToken,
    customerData,
    includeCredentials
  }) {
    this.backendUrl = backendUrl;
    this.getBearerToken = getBearerToken;
    this.customerData = customerData;
    this.includeCredentials = includeCredentials;
  }
  async getHeaders() {
    let headers = {
      "Content-Type": "application/json"
    };
    if (this.getBearerToken) {
      try {
        let token = await this.getBearerToken();
        headers.Authorization = `Bearer ${token}`;
      } catch (error) {
        console.error(`Failed to call getToken() in AutumnProvider`);
      }
    }
    return headers;
  }
  async handleFetch({
    path,
    method,
    body
  }) {
    body = method === "POST" ? JSON.stringify({
      ...body,
      customer_data: this.customerData || void 0
    }) : void 0;
    try {
      const response = await fetch(`${this.backendUrl}${path}`, {
        method,
        body,
        headers: await this.getHeaders(),
        credentials: this.includeCredentials ? "include" : void 0
      });
      return await toContainerResult({ response, logger: console });
    } catch (error) {
      logFetchError({
        method,
        backendUrl: this.backendUrl || "",
        path,
        error
      });
      return {
        data: null,
        error: new AutumnError({
          message: error.message,
          code: "fetch_failed"
        })
      };
    }
  }
  async post(path, body) {
    return await this.handleFetch({
      path,
      method: "POST",
      body
    });
  }
  async get(path) {
    return await this.handleFetch({
      path,
      method: "GET"
    });
  }
  async delete(path) {
    return await this.handleFetch({
      path,
      method: "DELETE"
    });
  }
  async createCustomer(params) {
    return await createCustomerMethod({
      client: this,
      params
    });
  }
  async getPricingTable() {
    return await getPricingTableMethod.bind(this)();
  }
  attach = attachMethod.bind(this);
  cancel = cancelMethod.bind(this);
  check = checkMethod.bind(this);
  track = trackMethod.bind(this);
  openBillingPortal = openBillingPortalMethod.bind(this);
  entities = {
    create: createEntityMethod.bind(this),
    get: getEntityMethod.bind(this),
    delete: deleteEntityMethod.bind(this)
  };
  referrals = {
    createCode: createCode.bind(this),
    redeemCode: redeemCode.bind(this)
  };
};

export {
  AutumnClient
};
